<template>
    <div class="relative">
        <div class="mx-auto w-full max-w-7xl pt-16 pb-20 text-center lg:py-48 lg:text-left">
            <div class="px-4 sm:px-8 lg:w-1/2 xl:pr-16">
                <h1 class="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                    {{ $t('Launch your career') }}
                </h1>
                <h2 class="text-5xl font-extrabold text-primary font-display">
                    CAMAQ
                </h2>
                <p class="mx-auto mt-3 max-w-md text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
                    {{ $t('Explore an aerospace challenge that suits your ambitions!') }}
                </p>
                <div class="mt-10 sm:flex sm:justify-center lg:justify-start">
                    <div class="rounded-md shadow">
                        <InertiaLink
                            :href="$page.props.locale == 'fr' ? '/emplois' : '/en/job-opportunities'"
                            class="flex w-full items-center justify-center rounded-md border border-transparent bg-primary px-8 py-3 text-base font-medium text-white hover:bg-camaq-600 md:py-4 md:px-10 md:text-lg"
                        >
                            {{ $t('Find your next job') }}
                        </InertiaLink>
                    </div>
                </div>
            </div>
        </div>

        <div class="relative w-full lg:absolute lg:inset-y-0 lg:right-0 lg:h-full lg:w-1/2">
            <div v-if="primeTimeOffer" class="inset-0 grid h-full place-items-center p-4 lg:absolute">
                <img class="absolute inset-0 h-full w-full object-cover" :src="primeTimeOffer.banner" alt="" />
                <div class="relative flex h-[430px] w-[400px] flex-col rounded-lg border border-[#667085] bg-[#F2F4F7] p-6">
                    <img :src="primeTimeOffer.company.logo" alt="" class="h-20 w-full rounded-lg bg-white object-contain p-2" />

                    <div class="mt-4 flex items-center space-x-2 text-[#667085]">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-map-pin" width="21" height="21" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
                            <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
                        </svg>
                        <span>{{ primeTimeOffer.city }}</span>
                    </div>

                    <p class="mt-10 font-bold uppercase tracking-wider">{{ primeTimeOffer.company.name }}</p>

                    <h2 class="text-xl font-bold uppercase leading-tight tracking-wider text-primary">
                        <InertiaLink
                            :href="$page.props.locale == 'fr' ? `/emplois/${primeTimeOffer.slug}` : `/job-opportunities/${primeTimeOffer.slug}`"
                            class="line-clamp-4"
                        >
                            {{ primeTimeOffer.title }}
                        </InertiaLink>
                    </h2>

                    <InertiaLink
                        :href="$page.props.locale == 'fr' ? `/emplois/${primeTimeOffer.slug}` : `/job-opportunities/${primeTimeOffer.slug}`"
                        class="mt-auto block w-full rounded bg-primary p-3 text-center text-sm font-bold uppercase tracking-wider text-white hover:bg-camaq-600"
                    >
                        {{ $t('Apply now') }}
                    </InertiaLink>
                </div>
            </div>

            <img v-else class="absolute inset-0 h-64 w-full object-cover lg:h-full" src="/images/home_3.jpg" alt="" />
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue';

    const props = defineProps({
        error: Boolean,
        offers: Array,
    });

    const primeTimeOffer = ref(null);

    onMounted(() => {
        if (props.offers.length) {
            primeTimeOffer.value = props.offers[0];
        }
    });
</script>
